import React from "react";
import { useEffect, useState } from "react";
import CustomTable from "components/CustomTable";
import { Button, Col } from "react-bootstrap";
import {
  useGetAllCommoditiesQuery,
  useGetAllMarketssQuery,
  useGetEmandiReportQuery,useEmandiLocationMasterQuery
} from "features/E-Mandi/EMandiApiSlice";
import { Card, CardBody } from "reactstrap";
import { useGetStatesQuery } from "services/locationApiSlice";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import { setBreadcrumbs } from "app/appSlice";
import ReactApexChart from "react-apexcharts";
import { Link, useNavigate } from "react-router-dom";
import GridViewIcon from "@mui/icons-material/GridView";
import MoneyIcon from "@mui/icons-material/Money";
import StackedLineChartIcon from "@mui/icons-material/StackedLineChart";
import { selectCurrentRoles } from "features/auth/authSlice";

const EmandiProc = () => {
  const [users, setUsers] = useState([]);
  const [pagination, setPagination] = useState({ page: 1, pageCount: 0 });
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  const [selectedCommodity, setSelectedCommodity] = useState("");
  const [selectedState, setSelectedState] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [commodityList, setCommodityList] = useState([]);
  const [marketList, setMarketList] = useState([]);
  const [selectedMarket, setSelectedMarket] = useState([]);
  const [viewChart, setViewChart] = useState("");
  const [showErrorMessage, setErrorMessage] = useState(false);
  const [showMarketError, setShowMarketError] = useState(false);
  const [showCommodityError, setShowCommodityError] = useState(false);
  const [showDateError, setShowDateError] = useState(false);
  const [Loading, setLoading] = useState(true);
  const [check, setCheck] = useState([]);
  const [chartData, setChartData] = useState({
    series: [],
    options: {},
  });
  const RolesFromToken = useSelector(selectCurrentRoles);

  const [activeCard, setActiveCard] = useState(
    RolesFromToken?.realm_access?.roles.includes("FPO") ||
      RolesFromToken?.realm_access?.roles.includes("CBBO")
      ? "e-mandi"
      : "mandi"
  );

  const { data: data, isLoading } = useGetEmandiReportQuery({
    selectedState,
    selectedCommodity,
    selectedMarket,
    dateFrom,
    dateTo,
    pagination,
  });

  const dateSet = new Set(data?.data?.results.map((item) => item.arrival_date));
  const sortedDates = Array.from(dateSet).sort(
    (a, b) => new Date(a) - new Date(b)
  );
  const groupedData = {};
  if (data?.data?.results && data.data.results[Symbol.iterator]) {
    for (const obj of data?.data?.results) {
      const market = obj.market;
      if (!groupedData[market]) {
        groupedData[market] = [];
      }
      groupedData[market].push(obj);
    }
  }
  const graphDict = [];
  for (const [market, dataPoints] of Object.entries(groupedData)) {
    const dataList = [];
    for (const date of sortedDates) {
      const dataPoint = dataPoints.find((item) => item.arrival_date === date);
      if (dataPoint) {
        dataList.push(dataPoint.modal_price);
      } else {
        dataList.push("");
      }
    }
    const entry = { name: market, data: dataList };
    graphDict.push(entry);
  }
  // console.log("graphDict", graphDict);

  // console.log("selectedCommodity", selectedCommodity)
  const { data: AllCommudity } = useGetAllCommoditiesQuery();
  const { data: AllMarkets } = useGetAllMarketssQuery({ selectedState });
  const { data: getStates } = useEmandiLocationMasterQuery();

  var modelprices = [];
  useEffect(() => {
    users?.map((item) => {
      modelprices.push(item?.modal_price);
    });
    //  console.log(modelprices,"modelprices")
  }, [data]);

  useEffect(() => {
    const uniqueDates = new Set();
    users?.forEach((item) => {
      uniqueDates.add(item?.arrival_date);
    });
    const uniqueDatesArray = Array.from(uniqueDates);
    setCheck(uniqueDatesArray);
  }, [users, data, dateFrom, dateTo]);

  useEffect(() => {
    if (AllCommudity !== undefined) {
      setCommodityList(AllCommudity?.data);
    }
  }, [AllCommudity]);

  useEffect(() => {
    if (getStates !== undefined) {
      setStateList(getStates?.data);
    }
  }, [getStates]);

  useEffect(() => {
    if (AllMarkets && AllMarkets.data.length > 0) {
      const filterMarketNames = [];
      AllMarkets.data.map((page) =>
        filterMarketNames.push({ label: page.market, value: page.market })
      );
      setMarketList(filterMarketNames);
      setLoading(false);
    }
  }, [AllMarkets]);

  useEffect(() => {
    const dataFromApi = data?.data?.results ? data?.data.results : [];
    const paginationFromApi = data?.data?.pages
      ? { page: data?.data?.current_page, pageCount: data?.data?.pages }
      : pagination;

    setUsers(dataFromApi);
    setPagination(paginationFromApi);
  }, [data]);

  // var arr = [{ "name":"Barabanki" , "data":  ["200", "300", "500"] },{ name: "allahabd", data: ["900", "800", "700"] }, ]
  // var arr = ["Gulavati" , ""]
  // Simulate fetching chart data from an API or other source
  useEffect(() => {
    const fetchedChartData = {
      // series  : [{ name: selectedCommodity, data: modelprices ? modelprices : "" }],
      series: graphDict,
      options: {
        chart: {
          type: "bar",
          height: 500,
        },
        xaxis: {
          categories: [...check],
        },
      },
    };
    setChartData(fetchedChartData);
  }, [data, dateFrom, dateTo]);

  const columns = [
    { field: "state", headerName: "State", width: 140 },
    { field: "district", headerName: "District", width: 150 },
    { field: "commodity", headerName: " Commodity ", width: 200 },
    { field: "variety", headerName: "Variety", width: 130 },
    { field: "market", headerName: "Market", width: 150 },
    { field: "arrival_date", headerName: "Arrival Date", width: 140 },
    { field: "min_price", headerName: "Min price", width: 130 },
    { field: "max_price", headerName: "Max price", width: 120 },
    { field: "modal_price", headerName: "Modal Price (Qtl)", width: 180 },
  ];
  const tableData = {
    rows: users,
    columns: columns,
    paginationState: [pagination, setPagination],
    isLoading: isLoading,
  };

  const currentDate = new Date();
  const sevenDaysAgo = new Date();
  sevenDaysAgo.setDate(currentDate.getDate() - 7);

  // Convert the dates to string format for the input element
  const currentDateString = currentDate.toISOString().split("T")[0];
  const sevenDaysAgoString = sevenDaysAgo.toISOString().split("T")[0];

  const handleDateChange = (e) => {
    let date = new Date(e.target.value);
    let dateMDY = `${date.getFullYear()}-${date.getMonth() +
      1}-${date.getDate()}`;
    setDateFrom(dateMDY);
    setShowDateError(false);
  };
  const handleDateChange2 = (e) => {
    let date = new Date(e.target.value);
    let dateMDY = `${date.getFullYear()}-${date.getMonth() +
      1}-${date.getDate()}`;
    setDateTo(dateMDY);
    setShowDateError(false);
  };

  //state options
  const handleStateOptions = () => {
    let responseAgentArray = [];
    stateList.map((state) => {
      responseAgentArray.push({
        value: state.state,
        label: state.state,
        ConditionName: "state",
      });
    });
    return responseAgentArray;
  };
  const onLocationChange = (event) => {
    setSelectedState(event?.label);
    setErrorMessage(false);
  };

  //commodity options
  const handleCommodityOptions = () => {
    let responseArray = [];
    commodityList?.map((item) => {
      responseArray.push({ label: item.commodity });
    });
    return responseArray;
  };
  const onCommodityChange = (event) => {
    setSelectedCommodity(event?.label);
    setShowCommodityError(false);
  };

  const onMarketChange = (event) => {
    const currentSelectedMarket = event?.map((item) => item.label);
    setSelectedMarket(JSON.stringify(currentSelectedMarket));
    setShowMarketError(false);
  };

  const customStyles = {
    control: (base) => ({
      ...base,
      height: 40,
      minHeight: 40,
      zIndex: 100,
    }),
  };

  const dispatch = useDispatch();
  useEffect(() => {
    const breadcrumbs = [
      { name: "Dashboard", link: "/dashboard" },
      { name: "Trading", link: "" },
    ];

    dispatch(setBreadcrumbs(breadcrumbs));
  }, []);

  const handleClick = (event) => {
    if (selectedState == "") {
      setErrorMessage(true);
      return;
    } else if (selectedMarket == "") {
      setShowMarketError(true);
    } else if (selectedCommodity == "") {
      setShowCommodityError(true);
      return;
    } else if (dateFrom == "" && dateTo == "") {
      setShowDateError(true);
      return;
    } else {
      setViewChart(event);
    }
  };
  const handleClick2 = (event) => {
    setViewChart(event);
  };
  const Navigate = useNavigate();
  const handleActiveCard = (cardName) => {
    Navigate(cardName);
  };

  return (
    <>
      <Card className="p-1 mt-2">
        <CardBody className="p-1 p-lg-3">
          <div className="row ">
            <Col lg="2">
              <label className="text-gray mb-1 mt-1"> State</label>
              <Select
                placeholder={"Select.."}
                options={handleStateOptions()}
                onChange={onLocationChange}
                styles={customStyles}
              />
              {showErrorMessage ? (
                <span style={{ color: "red" }}>Please Select State </span>
              ) : (
                ""
              )}
            </Col>

            <Col lg="2">
              <div className="d-flex justify-content-between">
                <label className="text-gray mb-1 mt-1"> Market</label>
              </div>
              <Select
                isMulti={true}
                isLoading={Loading}
                options={marketList}
                onChange={onMarketChange}
                styles={customStyles}
              />
              {showMarketError ? (
                <span style={{ color: "red" }}>Please Select Market </span>
              ) : (
                ""
              )}
            </Col>

            <Col lg="2">
              <div className="d-flex justify-content-between">
                <label className="text-gray mb-1 mt-1"> Commodity</label>
                {selectedCommodity !== "" ? (
                  <span
                    className="mdi mdi-close"
                    onClick={() => setSelectedCommodity("")}
                  ></span>
                ) : (
                  ""
                )}
              </div>
              <Select
                value={selectedCommodity}
                placeholder={
                  selectedCommodity === "" ? "Select..." : selectedCommodity
                }
                options={handleCommodityOptions()}
                onChange={onCommodityChange}
                styles={customStyles}
              />
              {showCommodityError ? (
                <span style={{ color: "red" }}>Please Select Commodity </span>
              ) : (
                ""
              )}
            </Col>

            <Col lg="2" sm="6" xs="6" md="3">
              <label className="text-gray mb-1 d-block mt-1">Date From</label>
              <input
                type="date"
                className="inputBoxCss"
                max={currentDateString}
                min={sevenDaysAgoString}
                style={{
                  border: "1px solid #ced4da",
                  color: "grey",
                  height: "40px",
                }}
                onChange={(e) => handleDateChange(e)}
              ></input>
              {showDateError ? (
                <p style={{ color: "red" }}> Please Select Date </p>
              ) : (
                ""
              )}
            </Col>

            <Col lg="2" sm="6" xs="6" md="3">
              <label className="text-gray mb-1 d-block mx-3 mt-1">
                Date To
              </label>
              <input
                type="date"
                className="inputBoxCss"
                max={currentDateString}
                min={sevenDaysAgoString}
                style={{
                  border: "1px solid #ced4da",
                  color: "grey",
                  height: "40px",
                }}
                onChange={(e) => handleDateChange2(e)}
              ></input>
              {showDateError ? (
                <p style={{ color: "red" }}> Please Select Date </p>
              ) : (
                ""
              )}
            </Col>
            <Col lg="2" sm="12" xs="12" md="3" className="mt-1">
              <div className="text-center">
                {viewChart !== "chart" ? (
                  <Button
                    className="mt-4"
                    style={{ padding: "12px" }}
                    onClick={() => handleClick("chart")}
                  >
                    View Data
                  </Button>
                ) : (
                  <Button className="mt-4" onClick={() => handleClick2("list")}>
                    View List
                  </Button>
                )}
              </div>
            </Col>
          </div>
          <hr></hr>

          {viewChart === "chart" ? (
            <div className="mt-3">
              <ReactApexChart
                options={chartData.options}
                series={chartData.series}
                type="bar"
                height={420}
              />
            </div>
          ) : (
            <div style={{ marginTop: "-2%" }}>
              <CustomTable
                rows={tableData.rows}
                columns={tableData.columns}
                paginationState={tableData.paginationState}
                loading={tableData.isLoading}
              />
            </div>
          )}
        </CardBody>
      </Card>
    </>
  );
};

export default EmandiProc;
